import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Switch, Route } from 'react-router-dom';

import { connect } from 'react-redux';
import NewsIndexPage from './NewsIndexPage';
import NewsDetailPage from './NewsDetailPage';
import NewsCreatePage from './NewsCreatePage';

function NewsPage() {
  return (
    <Switch>
      <Route path="/admin/news/add" component={NewsCreatePage} />
      <Route path="/admin/news/:newsID" component={NewsDetailPage} />
      <Route exact path="/admin/news" component={NewsIndexPage} />
    </Switch>
  );
}
// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

NewsPage.propTypes = {
};

NewsPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(NewsPage));
